<div class="card p-4">
    <h4 *ngIf="patientDetails" class="mb-4">Patient name - <span class="fw-bold">{{ patientDetails.patient_name }}</span></h4>
    <div class="w-25 mb-4">
        <p-multiSelect [options]="stepOptions" [(ngModel)]="selectedSteps" (onChange)="filterEvents()"
        optionLabel="label" optionValue="value" placeholder="Select Steps">
        </p-multiSelect>
    </div>
    <!-- Multiselect dropdown for filtering -->
    
    <div class="d-flex justify-content-center">
        <div class="w-75">
            <p-timeline [value]="filteredEvents " align="alternate">
                <ng-template pTemplate="content" let-event>
                    <!-- REGISTRATION -->
                    <div *ngIf="event.stepName === 'REGISTRATION'" class="border-circle">
                        <div>
                            <p class="fw-bold">{{event.stepName}}</p>
                            <p><span class="fst-italic text-black-50 me-2">Lead source:</span> 
                                <span class="fw-bold">{{ event.lead_source }}</span>
                            </p>
                        </div>
                        <div class="d-flex flex-column align-items-center justify-content-between date-box">
                            <div>{{ event.date_created | date: 'MMM'}}</div>
                            <div class="fs-1">{{ event.date_created | date: 'd'}}</div>
                            <div>{{ event.date_created | date: 'y'}}</div>
                        </div>
                        
                    </div>
                    <div></div>
                    <!-- INDUCTION -->
                    <div *ngIf="event.stepName === 'INDUCTION'" class="border-circle">
                        <div>
                            <p class="fw-bold">{{event.stepName}}</p>
                        </div>
                        <div class="d-flex flex-column align-items-center justify-content-between date-box">
                            <div>{{ event.inductoin_date | date: 'MMM'}}</div>
                            <div class="fs-1">{{ event.inductoin_date | date: 'd'}}</div>
                            <div>{{ event.inductoin_date | date: 'y'}}</div>
                        </div>
                        
                    </div>
                    <!-- OPD -->
                    <div *ngIf="event.stepName === 'OPD'" class="border-circle">
                        <div>
                            <p class="fw-bold">{{ getOpdFollowupText(event, events) }}</p>
                            <p>
                                <span class="fst-italic text-black-50 me-2">Appointment date: </span>
                                <span>{{ event.appointment_date | date: 'EE, MMM d, y' }}</span>
                            </p>
                            <p>
                                <span class="fst-italic text-black-50 me-2">{{ event.assigned_to_role_name }}: </span>
                                <span class="fw-bold">{{ event.assigned_to_name }}</span>
                            </p>
                        </div>
                        <div class="d-flex flex-column align-items-center justify-content-between date-box">
                            <div>{{ event.date_created | date: 'MMM'}}</div>
                            <div class="fs-1">{{ event.date_created | date: 'd'}}</div>
                            <div>{{ event.date_created | date: 'y'}}</div>
                        </div>
                        
                    </div>
                    <!-- RPP -->
                    <div *ngIf="event.stepName === 'RPP'" class="border-circle">
                        <div>
                            <p class="fw-bold">{{event.stepName}}</p>
                            <p>
                                <span class="fst-italic text-black-50 me-2">Due Date:</span>
                                <span class="">{{ event.date_created | date: 'EE, MMM d, y'}}</span>
                            </p>
                            <p>
                                <span class="fst-italic text-black-50 me-2">Enrollment Date:</span>
                                <span>{{ event.date_created | date: 'EE, MMM d, y'}}</span></p>
                            <p>
                                <span class="fst-italic text-black-50 me-2">{{ event.assigned_to_role_name }}:</span>
                                <span class="fw-bold">{{ event.assigned_to_name }}</span>
                            </p>
                            <p class="mb-0">
                                <span class="fst-italic text-black-50 me-2">Councellor Sessions:</span> 
                                <span>{{ getCouncellorSessionCount(event) }}</span></p>
                        </div>
                        
                        <div class="d-flex flex-column align-items-center justify-content-between date-box">
                            <div>{{ event.date_created | date: 'MMM'}}</div>
                            <div class="fs-1">{{ event.date_created | date: 'd'}}</div>
                            <div>{{ event.date_created | date: 'y'}}</div>
                        </div>
                    </div>
                    <!-- ASSESSMENT -->
                    <div *ngIf="event.stepName === 'ASSESSMENT'" class="border-circle">
                        <p>{{event.stepName}}</p>
                    </div>
                    <!-- SESSION -->
                    <div *ngIf="event.stepName === 'SESSION'" class="border-circle">
                        <div>
                            <p class="fw-bold">{{getSessionName(event)}}</p>
                            <p>
                                <span class="fst-italic text-black-50 me-2">Session date:</span>
                                <span class="">{{ event.session_date | date: 'MMM d, y' }}</span>
                            </p>
                            <p>
                                <span class="fst-italic text-black-50 me-2">{{ event.filled_by_role || 'Doctor' }}:</span>
                                <span class="fw-bold">{{ event.created_by_user_name }}</span>
                            </p>
                        </div>
                        <div class="d-flex flex-column align-items-center justify-content-between date-box">
                            <div>{{ event.date_created | date: 'MMM'}}</div>
                            <div class="fs-1">{{ event.date_created | date: 'd'}}</div>
                            <div>{{ event.date_created | date: 'y'}}</div>
                        </div>
                        
                    </div>
                </ng-template>
                <!-- Opposite -->
                <ng-template pTemplate="opposite" let-event>
                    <!-- REGISTRATION -->
                    <div *ngIf="event.stepName === 'REGISTRATION'">
                        
                    </div>
                    <div></div>
                    <!-- INDUCTION -->
                    <div *ngIf="event.stepName === 'INDUCTION'">
                        
                    </div>
                    <!-- OPD -->
                    <div *ngIf="event.stepName === 'OPD'">
                        
                    </div>
                    <!-- RPP -->
                    <div *ngIf="event.stepName === 'RPP'">
                        
                    </div>
                    <!-- ASSESSMENT -->
                    <div *ngIf="event.stepName === 'ASSESSMENT'">
                        
                    </div>
                    <!-- SESSION -->
                    <div *ngIf="event.stepName === 'SESSION'">
                        
                    </div>
                </ng-template>
                <!-- Marker Template -->
                <ng-template pTemplate="marker" let-event>
                    <div class="marker-circle marker-pos">
                        <div 
                        class="inner"
                        [ngClass]="{
                            'registration-bg': event.stepName === 'REGISTRATION', 
                            'induction-bg': event.stepName === 'INDUCTION', 
                            'opd-bg': event.stepName === 'OPD', 
                            'rpp-bg': event.stepName === 'RPP', 
                            'assessment-bg': event.stepName === 'ASSESSMENT', 
                            'session-bg': event.stepName === 'SESSION'
                        }"
                        ></div>
                    </div>
                </ng-template>
            </p-timeline>
        </div>
    </div>
    
    

    

</div>